import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[autofocus]',
})
export class AutofocusDirective {
  private _autofocus;
  constructor(
    private el: ElementRef,
    private renderer2: Renderer2
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (this._autofocus || typeof this._autofocus === 'undefined') {
			//Deprecated Renderer method, use Renderer2 instead
      // this.renderer.invokeElementMethod(this.el.nativeElement, 'focus', []);

			// Use Renderer2 for better compatibility with Angular's rendering engine
			this.renderer2.selectRootElement(this.el.nativeElement).focus();
		}
  }

  @Input() set autofocus(condition: boolean) {
    this._autofocus = condition != false;
  }
}
